<!-- https://www.draw.io/#G1RxtAt-qtK-y5gCcP8pcUg2micsMxJJN7 -->
<template>
  <div id="batch">
    <route-list-dialog
      v-if="currentBag.id"
      :bag="currentBag"
      :batches="openRoutes"
      :showRoutesDialog="showRoutesDialog"
      v-on:close-dialog="showRoutesDialog = false"
    />
    <confirm-dialog
      :showDialogConfirm="showDialogConfirm"
      :message="message"
      v-on:close-dialog="showDialogConfirm = false"
      v-on:accept="confirmDelete"
    />
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 class="text-xs-center">
          <h1>Captura del Lote {{currentBag.batch_id}} 
              <span v-if="currentBag.status === 'CLOSE'">(Cerrado)</span></h1>
          <h2>Saco {{currentBag.batch_consecutive}}</h2>
        </v-flex>
        <v-flex xs12 class="text-xs-center">
          <v-btn color="success" @click="closeCurrentBag" :disabled="currentBag.status!=='OPEN'">Cerrar Saco</v-btn>
          <v-btn color="accent" @click.stop="showRoutesDialog = true" >Rutas</v-btn>
        </v-flex>
        <v-flex
          xs12
          v-if="currentBag.type === 'METAL'" 
        >
          <pivot 
            :default-show-settings="false"
            :data="data" 
            :fields="fields" 
            :row-field-keys="rowFieldKeys" 
            :col-field-keys="colFieldKeys" 
            :reducer="reducer"
            :show-settings-text="'Configuraciones'"
          >
          </pivot>
        </v-flex>
        <v-flex xs6 class="text-xs-center">
          <v-container>
          <v-layout row wrap>
            <v-flex v-if="currentBag.type === 'HIGH'" xs12>
              <metal-load-detail
                title="Carga de Metal del Saco"
                :detail="metalLoad"
              />
            </v-flex>
            <v-flex xs12 class="text-xs-center" >
              <h3>Contenido del Saco</h3>
            </v-flex>
            <v-flex v-if="currentBag.type === 'HIGH'" xs12>
              <purcharse-order-catalyst-detail
                :items="bagContents"
                :showDetails="false"
                :showRoute="true"
                :showOperations="false"
                :currentBag="currentBag"
                v-on:updated="updated"
              />
            </v-flex>
            <v-flex v-if="currentBag.type === 'HIGH'" xs12>
              <!-- The tops are stored in the HIGH BAG -->
              <purcharse-order-tops-detail
                header="Tops y Piezas por Kilo"
                :items="bagContents"
                :showRoute="true"
                :showOperations="false"
                :currentBag="currentBag"
              />
            </v-flex>
            <v-flex v-if="currentBag.type === 'LOW'" xs12>
              <purcharse-order-dust-detail
                :showRoute="true"
                :items="bagContents"
                :currentBag="currentBag"
                v-on:deleteItem="deleteItem"
              />
            </v-flex>
            <v-flex v-if="currentBag.type === 'METAL'" xs12>
              <purcharse-order-metal-detail
                :items="bagContents"
                :currentBag="currentBag"
                v-on:deleteItem="deleteItem"
              />
            </v-flex>
          </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs6 class="text-xs-center">
          <v-container>
           <v-layout row wrap >
            <v-flex xs12 class="text-xs-center" >
              <h3>Rutas</h3>
            </v-flex>
            <v-flex xs12>
              <route-route-detail
                :routes="currentBag.routes"
                :currentBag="currentBag" />
            </v-flex>
            <v-flex xs12>
              <v-btn color="success" @click="showNewRouteDialog = true">Nueva Ruta</v-btn>
              <v-dialog v-model="showNewRouteDialog" max-width="500px">
                <v-form  v-model="isNewRouteValid" onSubmit="return false;">
                <v-card>
                  <v-card-title primary-title>
                    <h1>Nueva Ruta</h1>
                  </v-card-title>
                  <v-card-text>
                        <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex 12>
                            <v-menu
                              ref="menuDate"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              >
                              <template slot="activator">
                                <v-text-field
                                  v-model="newRoute.real_date"
                                  label="Fecha de la ruta"
                                  prepend-icon="event"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="newRoute.real_date"
                                no-title
                                scrollable
                                v-on:click:date="updateDate"
                                >
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="menuDate = false">Cancelar</v-btn>
                                <v-btn flat color="primary" @click="$refs.menuDate.save(newRoute.real_date)">Seleccionar</v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            name="routeDescription"
                            label="Descripcion"
                            v-model="newRoute.description"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                            :items="drivers"
                            v-model="newRoute.user_id"
                            label="Recolector"
                            item-text="name"
                            item-value="id"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="closeNewRouteDialog">Cancelar</v-btn>
                    <v-btn color="blue-grey darken-2 white--text" @click="createRoute" :disabled="!isNewRouteValid">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
                </v-form>
              </v-dialog>
            </v-flex>
           </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>

import _ from 'lodash';


import {
  createNewBag,
  openBag,
  closeBag,
  getBag,
  addRoute,
  getBagContents,
  getBagSummarized
} from '../services/bag';
import {getDrivers} from '../services/drivers';
import {
  createRoute,
  getOpenRoutes,
  openRoute,
  closeRoute,
  getMetalLoadForRouteInBag,
} from '../services/route';
import { Pivot } from '@click2buy/vue-pivot-table'
import { removeLineItem } from '@/services/purcharseOrder';

export default {
  components:{
    Pivot
  },
  data() {
    return {
      data: Object.freeze([]),
      fields: [
        {
          key: 'metal_origin',
          getter: item => item.metal_origin,
          label: 'Origen'
        }, {
          key: 'metal_size',
          getter: item => item.metal_size,
          label: 'Tamaño'
        }, {
          key: 'metal_content',
          getter: item => item.metal_content,
          label: 'Contenido'
        },
        {
          key: 'metal_quantity',
          getter: item => item.metal_quantity,
          label: 'metal_quantity'
        }
      ],
      rowFieldKeys: ['metal_origin', 'metal_size'],
      colFieldKeys: ['metal_content'],
      reducer: (_sum, item) => {
        return item.metal_quantity
      },
      
      currentBag: {},
      currentBatch: {},
      defaultBag: {
        type: 'HIGH',
      },

      routesDontAssignedHeaders: [
        { text: 'Fecha', value: 'created_on'},
        { text: 'Ruta', value: 'description' },
        { text: 'Operador', value: 'name' },
        { text: 'Libras', value: 'real_pieces' },
        { text: 'Piedra', value: 'pounds' },
      ],

      newRoute: {
        real_date: new Date().toISOString().substr(0, 10),
      },
      defaultNewRoute: {
        description: '',
        user_id: null,
        real_date: new Date().toISOString().substr(0, 10),
      },
      drivers: [],
      openRoutes: [],
      bagContents: [],
      showNewRouteDialog: false,
      isNewRouteValid: false,
      required: [
        (v) => !!v || 'Campo requerido',
      ],
      errorStatus: '',

      showRoutesDialog: false,
      menuDate: false,
      metalLoad: [],
      showDialogConfirm: false,
      message: "",
      bagToDelete: {}
    };
  },
  computed: {
    notAssignedRoutes() {
      return  _.differenceBy(this.openRoutes, this.currentBag.routes, 'id');
    },
  },
  methods: {
    async confirmDelete() {
      try {
        const result = await removeLineItem(this.backToDelete.id);
        this.updated()
      } catch (error) {
        this.$emit('error', error);
      }
    },
    async deleteItem(event) {
        this.backToDelete = event
        this.message = `¿Estás seguro de que quieres eliminar la línea seleccionada?`
        this.showDialogConfirm = true
    },
    async closeNewRouteDialog() {
      this.showNewRouteDialog = false;
      this.newRoute = Object.assign({}, this.defaultRouteBag);
    },
    createRoute() {
      createRoute(this.newRoute)
        .then( (result) => {
          const newRoute = result.data;
          addRoute(this.currentBag.id, newRoute.id);
          return newRoute;
        })
        .then( (result) => {
          if (this.currentBag.routes ) {
            this.currentBag.routes.push(result);
          }
          this.$emit('success', 'Ruta creada con exito');
        })
        .catch( (error) =>  {
          this.$emit('error', error);
        });

      this.newRoute = Object.assign({}, this.defaultNewRoute);
      this.showNewRouteDialog = false;
    },

    updateDate(event) {
      this.newRoute.real_date = event;
    },

    async closeCurrentBag() {
      const result = await closeBag(this.currentBag.id);
      this.$router.push('/batch');
    },
    async loadBag() {
      try {
        const result = await getBag(this.$route.params.id);
        this.currentBag  = result.data;
        if(this.currentBag.type === 'METAL'){
          this.getSummarized()
        }
      } catch (err) {
        if (!err.response) {
            // network error
            this.errorStatus = 'Error: Error de red revise su conexión';
        } else {
            this.errorStatus = err.response.data.message;
        }
      }
    },
    async loadDrivers() {
      try {
        const results = await getDrivers();
        this.drivers = results.data;
      } catch (err) {
        if (!err.response) {
            // network error
            this.errorStatus = 'Error: Error de red revise su conexión';
        } else {
            this.errorStatus = err.response.data.message;
        }
      }
    },
    async loadOpenRoutes() {
      try {
        const openRoutesResponse = await getOpenRoutes();
        this.openRoutes = openRoutesResponse.data;
      } catch (err) {
        if (!err.response) {
            // network error
            this.errorStatus = 'Error: Error de red revise su conexión';
        } else {
            this.errorStatus = err.response.data.message;
        }
      }
    },
    async loadBagContents() {
      try {
        const bagContentsResults = await getBagContents(this.currentBag.id);
        this.bagContents = bagContentsResults.data;
      } catch (error) {
        this.$emit('error', error);
      }
    },
    async getSummarized(){
      const result = await getBagSummarized(this.currentBag.id);
      this.data = Object.freeze(result.data)
    },
    async loadMetalLoadForBag() {
      try {
        const result = await getMetalLoadForRouteInBag(undefined, this.currentBag);
        this.metalLoad = result.data;
      } catch (error) {
        this.$emit('error', error);
      }
    },
    async updated() {
      await this.loadBagContents();
      await this.loadMetalLoadForBag();
    },
  },

  async mounted() {
    await this.loadBag();
    await this.loadDrivers();
    await this.loadOpenRoutes();
    await this.loadBagContents();
    await this.loadMetalLoadForBag();

    if (this.errorStatus) {
      this.$emit('error', this.errorStatus);
      this.errorStatus = '';
    }
  },
};
</script>